import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FilesService {

  constructor(private http: HttpClient) { }

  downloadFileRequest(fileUrl): Observable<Blob> {
    return this.http.get(fileUrl, {
      responseType: 'blob',
    });
  }

  downloadFile(fileUrl) {
    this.downloadFileRequest(fileUrl)
      .subscribe((response) => {
        let fileName = fileUrl.split('/').pop();
        let a = document.createElement('a');
        let objectUrl = URL.createObjectURL(response);
        a.href = objectUrl;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        URL.revokeObjectURL(objectUrl);
      });
  }

  downloadMultipleFiles(filesUrls: string[]) {
    filesUrls.forEach(fileUrl => {
      this.downloadFile(fileUrl)
    })
  }
}
